/**
 * Supported locales by Medable. Values are as defined by Unicode Locale identifiers.
 *
 * Should be kept in sync with {@link https://gitlab.medable.com/product/web/i18n/-/blob/master/packages/core/src/constants/supported-locales.constants.ts?ref_type=heads SUPPORTED_LOCALES from '@medable/i18n-core'}.
 * In addition to that, includes the pseudo-locales `en-XA` and `ar-XB`.
 */
export var Locale;
(function (Locale) {
    Locale["af_ZA"] = "af-ZA";
    Locale["ar_AE"] = "ar-AE";
    Locale["ar_DZ"] = "ar-DZ";
    Locale["ar_EG"] = "ar-EG";
    Locale["ar_IL"] = "ar-IL";
    Locale["ar_KW"] = "ar-KW";
    Locale["ar_LB"] = "ar-LB";
    Locale["ar_QA"] = "ar-QA";
    Locale["ar_SA"] = "ar-SA";
    Locale["as_IN"] = "as-IN";
    Locale["bg_BG"] = "bg-BG";
    Locale["bn_IN"] = "bn-IN";
    Locale["bs_Latn_BA"] = "bs-Latn-BA";
    Locale["ca_ES"] = "ca-ES";
    Locale["ceb_PH"] = "ceb-PH";
    Locale["cs_CZ"] = "cs-CZ";
    Locale["da_DK"] = "da-DK";
    Locale["de_AT"] = "de-AT";
    Locale["de_BE"] = "de-BE";
    Locale["de_CH"] = "de-CH";
    Locale["de_DE"] = "de-DE";
    Locale["el_GR"] = "el-GR";
    Locale["en_AU"] = "en-AU";
    Locale["en_BE"] = "en-BE";
    Locale["en_CA"] = "en-CA";
    Locale["en_GB"] = "en-GB";
    Locale["en_HK"] = "en-HK";
    Locale["en_IE"] = "en-IE";
    Locale["en_IL"] = "en-IL";
    Locale["en_IN"] = "en-IN";
    Locale["en_JM"] = "en-JM";
    Locale["en_MY"] = "en-MY";
    Locale["en_NZ"] = "en-NZ";
    Locale["en_PH"] = "en-PH";
    Locale["en_SG"] = "en-SG";
    Locale["en_TW"] = "en-TW";
    Locale["en_US"] = "en-US";
    Locale["en_ZA"] = "en-ZA";
    Locale["es_419"] = "es-419";
    Locale["es_AR"] = "es-AR";
    Locale["es_CL"] = "es-CL";
    Locale["es_CO"] = "es-CO";
    Locale["es_CR"] = "es-CR";
    Locale["es_DO"] = "es-DO";
    Locale["es_ES"] = "es-ES";
    Locale["es_GT"] = "es-GT";
    Locale["es_MX"] = "es-MX";
    Locale["es_PA"] = "es-PA";
    Locale["es_PE"] = "es-PE";
    Locale["es_PR"] = "es-PR";
    Locale["es_US"] = "es-US";
    Locale["et_EE"] = "et-EE";
    Locale["fi_FI"] = "fi-FI";
    Locale["fil_PH"] = "fil-PH";
    Locale["fr_BE"] = "fr-BE";
    Locale["fr_CA"] = "fr-CA";
    Locale["fr_CH"] = "fr-CH";
    Locale["fr_DZ"] = "fr-DZ";
    Locale["fr_FR"] = "fr-FR";
    Locale["gl_ES"] = "gl-ES";
    Locale["gu_IN"] = "gu-IN";
    Locale["he_IL"] = "he-IL";
    Locale["hi_IN"] = "hi-IN";
    Locale["hil_PH"] = "hil-PH";
    Locale["hr_HR"] = "hr-HR";
    Locale["ht_HT"] = "ht-HT";
    Locale["hu_HU"] = "hu-HU";
    Locale["ilo_PH"] = "ilo-PH";
    Locale["it_CH"] = "it-CH";
    Locale["it_IT"] = "it-IT";
    Locale["ja_JP"] = "ja-JP";
    Locale["ka_GE"] = "ka-GE";
    Locale["kn_IN"] = "kn-IN";
    Locale["ko_KR"] = "ko-KR";
    Locale["lt_LT"] = "lt-LT";
    Locale["lv_LV"] = "lv-LV";
    Locale["ml_IN"] = "ml-IN";
    Locale["mr_IN"] = "mr-IN";
    Locale["ms_Arab_MY"] = "ms-Arab-MY";
    Locale["ms_Latn_MY"] = "ms-Latn-MY";
    Locale["ms_Latn_SG"] = "ms-Latn-SG";
    Locale["nb_NO"] = "nb-NO";
    Locale["nl_BE"] = "nl-BE";
    Locale["nl_NL"] = "nl-NL";
    Locale["nso_ZA"] = "nso-ZA";
    Locale["or_IN"] = "or-IN";
    Locale["pa_Guru_IN"] = "pa-Guru-IN";
    Locale["pl_PL"] = "pl-PL";
    Locale["pt_BR"] = "pt-BR";
    Locale["pt_PT"] = "pt-PT";
    Locale["ro_MD"] = "ro-MD";
    Locale["ro_RO"] = "ro-RO";
    Locale["ru_EE"] = "ru-EE";
    Locale["ru_IL"] = "ru-IL";
    Locale["ru_LT"] = "ru-LT";
    Locale["ru_LV"] = "ru-LV";
    Locale["ru_RU"] = "ru-RU";
    Locale["ru_UA"] = "ru-UA";
    Locale["sk_SK"] = "sk-SK";
    Locale["sl_SI"] = "sl-SI";
    Locale["sr_Cyrl_RS"] = "sr-Cyrl-RS";
    Locale["sr_Latn_RS"] = "sr-Latn-RS";
    Locale["st_ZA"] = "st-ZA";
    Locale["sv_FI"] = "sv-FI";
    Locale["sv_SE"] = "sv-SE";
    Locale["ta_IN"] = "ta-IN";
    Locale["ta_MY"] = "ta-MY";
    Locale["ta_SG"] = "ta-SG";
    Locale["te_IN"] = "te-IN";
    Locale["th_TH"] = "th-TH";
    Locale["tl_PH"] = "tl-PH";
    Locale["tn_ZA"] = "tn-ZA";
    Locale["tr_TR"] = "tr-TR";
    Locale["uk_UA"] = "uk-UA";
    Locale["ur_IN"] = "ur-IN";
    Locale["ur_PK"] = "ur-PK";
    Locale["vi_VN"] = "vi-VN";
    Locale["xh_ZA"] = "xh-ZA";
    Locale["zh_Hans_CN"] = "zh-Hans-CN";
    Locale["zh_Hans_MY"] = "zh-Hans-MY";
    Locale["zh_Hans_SG"] = "zh-Hans-SG";
    Locale["zh_Hant_HK"] = "zh-Hant-HK";
    Locale["zh_Hant_TW"] = "zh-Hant-TW";
    Locale["zu_ZA"] = "zu-ZA";
    // Pseudo-locales
    Locale["en_XA"] = "en-XA";
    Locale["ar_XB"] = "ar-XB";
})(Locale || (Locale = {}));
export var PseudoLocale;
(function (PseudoLocale) {
    PseudoLocale["en_XA"] = "en-XA";
    PseudoLocale["ar_XB"] = "ar-XB";
})(PseudoLocale || (PseudoLocale = {}));
//# sourceMappingURL=locales.js.map